const moment = require("moment");
const jobs = jobs => {
  var ptoJobs = jobs.filter(job => job.assigned_task === "20-0003");
  var sortedjobs = jobs.filter(job => job.assigned_task !== "20-0003");
  sortedjobs = sorter(sortedjobs, "assigned_task");
  sortedjobs = sortedjobs.concat(ptoJobs);
  return sortedjobs;
};
const workorders = jobs => {
  var ptoJobs = jobs.filter(job => job.assigned_task === "20-0003");
  var sortedjobs = jobs.filter(job => job.assigned_task !== "20-0003");
  sortedjobs = sorter(sortedjobs, "workOrderNbr");
  sortedjobs = sortedjobs.concat(ptoJobs);
  return sortedjobs;
};
const sorter = (stuff, key) => {
  return stuff.sort(function(a, b) {
    let custA = parseFloat(a[key].slice(0, 2));
    let custB = parseFloat(b[key].slice(0, 2));
    let wodA = parseFloat(a[key].slice(3, 7));
    let wodB = parseFloat(b[key].slice(3, 7));
    let derivA = a[key].slice(7, 8);
    let derivB = b[key].slice(7, 8);
    // console.log(custA, custB, custA > custB);

    if (custA > custB) {
      return 1;
    } else if (custB > custA) {
      return -1;
    } else if (a[key] === b[key]) {
      return moment.utc(a.datepurchased).diff(moment.utc(b.datepurchased));
    } else {
      if (wodA > wodB) {
        return 1;
      } else if (wodB > wodA) {
        return -1;
      } else {
        if (!derivB) {
          return -1;
        } else if (!derivA) {
          1;
        } else {
          if (derivA > derivB) {
            return 1;
          } else if (derivB > derivA) {
            return -1;
          }
        }
      }
    }
  });
};
const matentries = matentries => {
  return sorter(matentries, "workordernumber");
};

module.exports = {
  wods: workorders,
  assignments: jobs,
  matentries: matentries
};



// WEBPACK FOOTER //
// ./src/services/jobsort.js